import { ChangeDetectionStrategy, Component, computed, input, model, output } from '@angular/core';
import { AgentProfileDto } from '@workspace/data-types';
import { AuraEditWrapperComponent } from '@workspace/ng-aura';
import { AgentProfileDisplayComponent } from '../display/agent-profile-display.component';
import { AgentZoneActivityFormComponent } from '../zone-activity-form/agent-zone-activity-form.component';

export type AgentProfileSection =
  'network' | 'specialties' | 'zones' | 'cities' | 'bio' | 'socialLinks' | 'officeHours';

@Component({
  selector: 'etxe-agent-profile-edit',
  templateUrl: './agent-profile-edit.component.html',
  imports: [AuraEditWrapperComponent, AgentZoneActivityFormComponent, AgentProfileDisplayComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AgentProfileEditComponent {
  initialProfile = input.required<AgentProfileDto>();
  showMode = input.required<AgentProfileSection>();
  isEditing = model<boolean>(false);
  showDivider = input<boolean>(true);
  profileSaved = output<AgentProfileDto>();

  currentProfile = computed<AgentProfileDto>(() => this.initialProfile());

  sectionTitle = computed(() => {
    switch (this.showMode()) {
      case 'network':
        return "Type d'exercice & Réseau";
      case 'specialties':
        return 'Spécialités de transactions';
      case 'zones':
        return "Secteur d'intervention";
      case 'cities':
        return 'Communes prioritaires pour les alertes';
      case 'bio':
        return 'Présentation & Biographie';
      case 'socialLinks':
        return 'Réseaux sociaux & Liens web';
      case 'officeHours':
        return 'Adresse professionnelle & Horaires';
      default:
        return 'Profil professionnel';
    }
  });
}
